module.exports = __webpack_public_path__ + "media/images/lb/232-767040092132e21c0616a5529f9fa853.svg";